import React, { useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Container from "@mui/material/Container";
import HomeIcon from "@mui/icons-material/Home";
import DepartureBoardOutlined from "@mui/icons-material/DepartureBoardOutlined";
import ChildCareOutlinedIcon from "@mui/icons-material/ChildCareOutlined";
import PregnantWomanOutlinedIcon from "@mui/icons-material/PregnantWomanOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import SchoolIcon from "@mui/icons-material/School";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Restricted from "components/Restricted";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TableViewIcon from "@mui/icons-material/TableView";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import {
  AssignmentLate,
  BarChart,
  HealthAndSafety,
  StorageOutlined,
  SystemUpdateAlt,
} from "@mui/icons-material";
import { downloadExcel } from "react-export-table-to-excel";
import * as XLSX from "xlsx";
import axios from "axios";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Consolidado = () => {
  const [items, setItems] = React.useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("prop");
  const proyect = JSON.parse(token);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  const nav = useNavigate();

  //Theme
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  //Tabs Handlers
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //Select Handler
  const [comunidad, setComunidad] = React.useState("");
  const [totalNinos, setTotalNinos] = React.useState([]);
  const [totalMel, setTotalMel] = React.useState([]);
  const handleSelect = (event) => {
    setComunidad(event.target.value);
    setTotalNinos(
      dataConsolidadoNinos.filter((dat) => dat.comunidad === event.target.value)
    );
    setTotalMel(
      dataConsolidadoMel.filter((dat) => dat.comunidad === event.target.value)
    );
    console.log(totalNinos);
    console.log(totalMel);
    if (event.target.value === "") {
      setExpanded(!expanded);
    }
  };

  //Expand Handler
  const [expanded, setExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleViewTable = () => {
    setExpanded(!expanded);
  };

  // Radio Handlers
  const [exportRadio, setExportRadio] = React.useState("");
  const handleExportRadio = (event) => {
    setExportRadio(event.target.value);
  };

  // DatePicker Handlers
   const [fechaInicio, setFechaInicio] = React.useState(null);
   const [fechaFinal, setFechaFinal] = React.useState(null);

  ///////////////////////////  EXPORTAR EXCEL ESTADISTICAS SALUD  /////////////////////////////////////////////////////////////
  const [dataConsolidadoSaludSexo, setDataConsolidadoSaludSexo] =
    React.useState([]);
  const [
    dataConsolidadoSaludDiscapacidad,
    setDataConsolidadoSaludDiscapacidad,
  ] = React.useState([]);
  const [dataConsolidadoSaludMovilidad, setDataConsolidadoSaludMovilidad] =
    React.useState([]);
  const [dataConsolidadoSaludFactores, setDataConsolidadoSaludFactores] =
    React.useState([]);
  const [
    dataConsolidadoSaludEnfermedadesEdades,
    setDataConsolidadoSaludEnfermedadesEdades,
  ] = React.useState([]);
  const [
    dataConsolidadoSaludEnfermedadesSexos,
    setDataConsolidadoSaludEnfermedadesSexos,
  ] = React.useState([]);
  const [dataConsolidadoSaludEdad, setDataConsolidadoSaludEdad] =
    React.useState([]);
  const [dataConsolidadoSaludEdadSexo, setDataConsolidadoSaludEdadSexo] =
    React.useState([]);

  const handleDownloadExcelPrueba = () => {
    const dataSets = [
      {
        sheetName: "Etnias",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total Beneficiarios",
          "Mujeres Mestizas (0-5 años)",
          "Hombres Mestizos (0-5 años)",
          "Mujeres Mestizas (6-19 años)",
          "Hombres Mestizos (6-19 años)",
          "Mujeres Mestizas (20-64 años)",
          "Hombres Mestizos (20-64 años)",
          "Mujeres Mestizas (65 años o más)",
          "Hombres Mestizos (65 años o más)",
          "Mujeres Wayuu (0-5 años)",
          "Hombres Wayuu (0-5 años)",
          "Mujeres Wayuu (6-19 años)",
          "Hombres Wayuu (6-19 años)",
          "Mujeres Wayuu (20-64 años)",
          "Hombres Wayuu (20-64 años)",
          "Mujeres Wayuu (65 años o más)",
          "Hombres Wayuu (65 años o más)",
          "Mujeres Añu (0-5 años)",
          "Hombres Añu (0-5 años)",
          "Mujeres Añu (6-19 años)",
          "Hombres Añu (6-19 años)",
          "Mujeres Añu (20-64 años)",
          "Hombres Añu (20-64 años)",
          "Mujeres Añu (65 años o más)",
          "Hombres Añu (65 años o más)",
          "Mujeres Japreria (0-5 años)",
          "Hombres Japreria (0-5 años)",
          "Mujeres Japreria (6-19 años)",
          "Hombres Japreria (6-19 años)",
          "Mujeres Japreria (20-64 años)",
          "Hombres Japreria (20-64 años)",
          "Mujeres Japreria (65 años o más)",
          "Hombres Japreria (65 años o más)",
          "Mujeres Yanomami (0-5 años)",
          "Hombres Yanomami (0-5 años)",
          "Mujeres Yanomami (6-19 años)",
          "Hombres Yanomami (6-19 años)",
          "Mujeres Yanomami (20-64 años)",
          "Hombres Yanomami (20-64 años)",
          "Mujeres Yanomami (65 años o más)",
          "Hombres Yanomami (65 años o más)",
          "Mujeres Bari (0-5 años)",
          "Hombres Bari (0-5 años)",
          "Mujeres Bari (6-19 años)",
          "Hombres Bari (6-19 años)",
          "Mujeres Bari (20-64 años)",
          "Hombres Bari (20-64 años)",
          "Mujeres Bari (65 años o más)",
          "Hombres Bari (65 años o más)",
          "Mujeres Yukpa (0-5 años)",
          "Hombres Yukpa (0-5 años)",
          "Mujeres Yukpa (6-19 años)",
          "Hombres Yukpa (6-19 años)",
          "Mujeres Yukpa (20-64 años)",
          "Hombres Yukpa (20-64 años)",
          "Mujeres Yukpa (65 años o más)",
          "Hombres Yukpa (65 años o más)",
        ],
        data: dataConsolidadoSaludSexo,
      },
      {
        sheetName: "Discapacidades",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total Beneficiarios",
          "Ninguna Discapacidad Mujeres (0-5 años)",
          "Ninguna Discapacidad Hombres (0-5 años)",
          "Ninguna Discapacidad Mujeres (6-19 años)",
          "Ninguna Discapacidad Hombres (6-19 años)",
          "Ninguna Discapacidad Mujeres (20-64 años)",
          "Ninguna Discapacidad Hombres (20-64 años)",
          "Ninguna Discapacidad Mujeres (65 años o más)",
          "Ninguna Discapacidad Hombres (65 años o más)",
          "Discapacidad Física Mujeres (0-5 años)",
          "Discapacidad Física Hombres (0-5 años)",
          "Discapacidad Física Mujeres (6-19 años)",
          "Discapacidad Física Hombres (6-19 años)",
          "Discapacidad Física Mujeres (20-64 años)",
          "Discapacidad Física Hombres (20-64 años)",
          "Discapacidad Física Mujeres (65 años o más)",
          "Discapacidad Física Hombres (65 años o más)",
          "Discapacidad Intelectual Mujeres (0-5 años)",
          "Discapacidad Intelectual Hombres (0-5 años)",
          "Discapacidad Intelectual Mujeres (6-19 años)",
          "Discapacidad Intelectual Hombres (6-19 años)",
          "Discapacidad Intelectual Mujeres (20-64 años)",
          "Discapacidad Intelectual Hombres (20-64 años)",
          "Discapacidad Intelectual Mujeres (65 años o más)",
          "Discapacidad Intelectual Hombres (65 años o más)",
          "Discapacidad Múltiple Mujeres (0-5 años)",
          "Discapacidad Múltiple Hombres (0-5 años)",
          "Discapacidad Múltiple Mujeres (6-19 años)",
          "Discapacidad Múltiple Hombres (6-19 años)",
          "Discapacidad Múltiple Mujeres (20-64 años)",
          "Discapacidad Múltiple Hombres (20-64 años)",
          "Discapacidad Múltiple Mujeres (65 años o más)",
          "Discapacidad Múltiple Hombres (65 años o más)",
          "Discapacidad Sensorial Mujeres (0-5 años)",
          "Discapacidad Sensorial Hombres (0-5 años)",
          "Discapacidad Sensorial Mujeres (6-19 años)",
          "Discapacidad Sensorial Hombres (6-19 años)",
          "Discapacidad Sensorial Mujeres (20-64 años)",
          "Discapacidad Sensorial Hombres (20-64 años)",
          "Discapacidad Sensorial Mujeres (65 años o más)",
          "Discapacidad Sensorial Hombres (65 años o más)",
        ],
        data: dataConsolidadoSaludDiscapacidad,
      },
      {
        sheetName: "Movilidad",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total Beneficiarios",
          "Local Mujeres (0-5 años)",
          "Local Hombres (0-5 años)",
          "Local Mujeres (6-19 años)",
          "Local Hombres (6-19 años)",
          "Local Mujeres (20-64 años)",
          "Local Hombres (20-64 años)",
          "Local Mujeres (65 años o más)",
          "Local Hombres (65 años o más)",
          "Desplazados Mujeres (0-5 años)",
          "Desplazados Hombres (0-5 años)",
          "Desplazados Mujeres (6-19 años)",
          "Desplazados Hombres (6-19 años)",
          "Desplazados Mujeres (20-64 años)",
          "Desplazados Hombres (20-64 años)",
          "Desplazados Mujeres (65 años o más)",
          "Desplazados Hombres (65 años o más)",
          "Refugiados Mujeres (0-5 años)",
          "Refugiados Hombres (0-5 años)",
          "Refugiados Mujeres (6-19 años)",
          "Refugiados Hombres (6-19 años)",
          "Refugiados Mujeres (20-64 años)",
          "Refugiados Hombres (20-64 años)",
          "Refugiados Mujeres (65 años o más)",
          "Refugiados Hombres (65 años o más)",
          "Retornados Mujeres (0-5 años)",
          "Retornados Hombres (0-5 años)",
          "Retornados Mujeres (6-19 años)",
          "Retornados Hombres (6-19 años)",
          "Retornados Mujeres (20-64 años)",
          "Retornados Hombres (20-64 años)",
          "Retornados Mujeres (65 años o más)",
          "Retornados Hombres (65 años o más)",
          "Pendular Mujeres (0-5 años)",
          "Pendular Hombres (0-5 años)",
          "Pendular Mujeres (6-19 años)",
          "Pendular Hombres (6-19 años)",
          "Pendular Mujeres (20-64 años)",
          "Pendular Hombres (20-64 años)",
          "Pendular Mujeres (65 años o más)",
          "Pendular Hombres (65 años o más)",
        ],
        data: dataConsolidadoSaludMovilidad,
      },
      {
        sheetName: "Consolidado Factores de Riesgo",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total Beneficiarios",
          "Mujeres con Abuso Emocional o Psicológico",
          "Hombres con Abuso Emocional o Psicológico",
          "Mujeres con Abuso Físico",
          "Hombres con Abuso Físico",
          "Mujeres con Abuso Sexual",
          "Hombres con Abuso Sexual",
          "Mujeres con Embarazo Adolescente",
          "Hombres con Embarazo Adolescente",
          "Mujeres con Explotación Sexual",
          "Hombres con Explotación Sexual",
          "Mujeres con Falta de Documentos de Identidad",
          "Hombres con Falta de Documentos de Identidad",
          "Mujeres con Matrimonio Infantil",
          "Hombres con Matrimonio Infantil",
          "Mujeres con Negligencia",
          "Hombres con Negligencia",
          "Mujeres No Acompañado (<18 años)",
          "Hombres No Acompañado (<18 años)",
          "Mujeres con Trabajo Infantil",
          "Hombres con Trabajo Infantil",
          "Mujeres con Trastorno Mental",
          "Hombres con Trastorno Mental",
        ],
        data: dataConsolidadoSaludFactores,
      },
      {
        sheetName: "Consolidado Tipo de Enfermedad",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total Beneficiarios",
          "Adulto Sano Mujeres",
          "Adulto Sano Hombres",
          "Mujeres con Algunas Enfermedades Infecciosas o Parasitarias",
          "Hombres con Algunas Enfermedades Infecciosas o Parasitarias",
          "Mujeres con Anomalías en el Desarrollo Prenatal",
          "Hombres con Anomalías en el Desarrollo Prenatal",
          "Mujeres con Condiciones Reslacionadas con la Salud Sexual",
          "Hombres con Condiciones Reslacionadas con la Salud Sexual",
          "Mujeres con Embarazo, Parto, Puerperio o Trastornos Hormonales",
          "Hombres con Embarazo, Parto, Puerperio o Trastornos Hormonales",
          "Mujeres con Enfermedades de la Piel y Anexos",
          "Hombres con Enfermedades de la Piel y Anexos",
          "Mujeres con Enfermedades de la Sangre o de los Órganos Hematopoyéticos",
          "Hombres con Enfermedades de la Sangre o de los Órganos Hematopoyéticos",
          "Mujeres con Enfermedades de las Glándulas Mamarias",
          "Hombres con Enfermedades de las Glándulas Mamarias",
          "Mujeres con Enfermedades Degenerativas",
          "Hombres con Enfermedades Degenerativas",
          "Mujeres con Enfermedades del Aparato Digestivo",
          "Hombres con Enfermedades del Aparato Digestivo",
          "Mujeres con Enfermedades del Aparato Genitourinario",
          "Hombres con Enfermedades del Aparato Genitourinario",
          "Mujeres con Enfermedades del Aparato Respiratorio",
          "Hombres con Enfermedades del Aparato Respiratorio",
          "Mujeres con Enfermedades del Ojo y sus Anexos",
          "Hombres con Enfermedades del Ojo y sus Anexos",
          "Mujeres con Enfermedades del Oído o de la Apofis Mastoides",
          "Hombres con Enfermedades del Oído o de la Apofis Mastoides",
          "Mujeres con Enfermedades del Sistema Circulatorio o Cardiovascular",
          "Hombres con Enfermedades del Sistema Circulatorio o Cardiovascular",
          "Mujeres con Enfermedades del Sistema Inmunitario",
          "Hombres con Enfermedades del Sistema Inmunitario",
          "Mujeres con Enfermedades del Sistema Músculo Esqueléctico, de los nervios o del Tejido Conectivo",
          "Hombres con Enfermedades del Sistema Músculo Esqueléctico, de los nervios o del Tejido Conectivo",
          "Mujeres con Enfermedades del Sistema Nervioso",
          "Hombres con Enfermedades del Sistema Nervioso",
          "Mujeres con Enfermedades Endocrinas, Nutricionales o Metabólicas",
          "Hombres con Enfermedades Endocrinas, Nutricionales o Metabólicas",
          "Mujeres con Enfermedades Odontológicas",
          "Hombres con Enfermedades Odontológicas",
          "Mujeres con Factores que Incluyen en el Estado de Salud o el Contacto con los Servicios de Salud",
          "Hombres con Factores que Incluyen en el Estado de Salud o el Contacto con los Servicios de Salud",
          "Mujeres con Neoplacias",
          "Hombres con Neoplacias",
          "Niño/Adolescente Sano Mujeres",
          "Niño/Adolescente Sano Hombres",
          "Mujeres con Trastornos Mentales, del Comportamiento y del Neurodesarrollo",
          "Hombres con Trastornos Mentales, del Comportamiento y del Neurodesarrollo",
          "Mujeres con Traumatismos, Intoxicaciones u Otras Consecuencias de Causas Externas de Morbilidad o Mortalidad",
          "Hombres con Traumatismos, Intoxicaciones u Otras Consecuencias de Causas Externas de Morbilidad o Mortalidad",
        ],
        data: dataConsolidadoSaludEnfermedadesSexos,
      },
      {
        sheetName: "Consolidado Grupo Etario",
        headers: [
          "Comunidad",
          "TOTAL NIÑAS 0-5 AÑOS",
          "TOTAL NIÑAS 6-19 AÑOS",
          "TOTAL MUJERES 20-64 AÑOS",
          "TOTAL MUJERES MAYORES DE 65 AÑOS",
          "TOTAL NIÑOS 0-5 AÑOS",
          "TOTAL NIÑOS 6-19 AÑOS",
          "TOTAL HOMBRES 20-64 AÑOS",
          "TOTAL HOMBRES MAYORES DE 65 AÑOS",
        ],
        data: dataConsolidadoSaludEdad,
      },
      {
        sheetName: "Consolidado Rango de Edad",
        headers: [
          "Comunidad",
          "TOTAL BENEFICIARIOS",
          "TOTAL NIÑAS",
          "TOTAL NIÑOS",
          "TOTAL MUJERES",
          "TOTAL HOMBRES",
        ],
        data: dataConsolidadoSaludEdadSexo,
      },
      // Puedes agregar más conjuntos de datos aquí
    ];

    const wb = XLSX.utils.book_new();

    dataSets.forEach((dataSet) => {
      const ws = XLSX.utils.json_to_sheet([]); // Inicializamos una hoja vacía

      // Agregamos los encabezados en la primera fila
      XLSX.utils.sheet_add_aoa(ws, [dataSet.headers], { origin: "A1" });

      // Agregamos los datos JSON, comenzando en la segunda fila ('A2')
      // y sin omitir la cabecera (ya la agregamos manualmente)
      XLSX.utils.sheet_add_json(ws, dataSet.data, {
        origin: "A2",
        skipHeader: true,
      });

      XLSX.utils.book_append_sheet(wb, ws, dataSet.sheetName);
    });

    XLSX.writeFile(
      wb,
      `ESTADISTICAS GENERALES - ${new Date().toLocaleDateString("en-GB")}.xlsx`
    );
  };

  const handleDownloadConsolidadoNutri = () => {
    const dataSets = [
      {
        sheetName: "NNA",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total de Tamizados",
          "Total Niñas",
          "Total Niños",
          "Niñas de 6 a 23 meses",
          "Niños de 6 a 23 meses",
          "Niñas de 24 a 59 meses",
          "Niños de 24 a 59 meses",
          "Niñas de 6 a 23 meses (SAM)",
          "Niños de 6 a 23 meses (SAM)",
          "Niñas de 24 a 59 meses (SAM)",
          "Niños de 24 a 59 meses (SAM)",
          "Niñas de 6 a 23 meses (MAM)",
          "Niños de 6 a 23 meses (MAM)",
          "Niñas de 24 a 59 meses (MAM)",
          "Niños de 24 a 59 meses (MAM)",
          "Niñas de 6 a 23 meses (Adecuado)",
          "Niños de 6 a 23 meses (Adecuado)",
          "Niñas de 24 a 59 meses (Adecuado)",
          "Niños de 24 a 59 meses (Adecuado)",
          "Niñas de 6 a 23 meses (Micronutrientes)",
          "Niños de 6 a 23 meses (Micronutrientes)",
          "Niñas de 24 a 59 meses (Micronutrientes)",
          "Niños de 24 a 59 meses (Micronutrientes)",
          "Niñas de 6 a 23 meses (PA)",
          "Niños de 6 a 23 meses (PA)",
          "Niñas de 24 a 59 meses (PA)",
          "Niños de 24 a 59 meses (PA)",
          "Total PA",
          "Total Adecuado",
          "Total Puntaje Z entre -2 y -1",
          "Población Indígena (NNA)",
          "Discapacitados (NNA)",
          "Total SAM",
          "Total MAM",
          "Total Sobrepeso",
          "Total Obesidad",
          "Total Niñas Adecuadas con Discapacidad 6-23 Meses",
          "Total Niños Adecuadas con Discapacidad 6-23 Meses",
          "Total Niñas Adecuadas con Discapacidad 24-59 Meses",
          "Total Niños Adecuados con Discapacidad 24-59 Meses",
          "Total Niñas SAM con Discapacidad 6-23 Meses",
          "Total Niños SAM con Discapacidad 6-23 Meses",
          "Total Niñas SAM con Discapacidad 24-59 Meses",
          "Total Niños SAM con Discapacidad 24-59 Meses",
          "Total Niñas MAM con Discapacidad 6-23 Meses",
          "Total Niños MAM con Discapacidad 6-23 Meses",
          "Total Niñas MAM con Discapacidad 24-59 Meses",
          "Total Niños MAM con Discapacidad 24-59 Meses",
          "Total Niñas Adecuadas Indígenas 6-23 Meses",
          "Total Niños Adecuados Indígenas 6-23 Meses",
          "Total Niñas Adecuadas Indígenas 24-59 Meses",
          "Total Niños Adecuados Indígenas 24-59 Meses",
          "Total Niñas SAM Indígenas 6-23 Meses",
          "Total Niños SAM Indígenas 6-23 Meses",
          "Total Niñas SAM Indígenas 24-59 Meses",
          "Total Niños SAM Indígenas 24-59 Meses",
          "Total Niñas MAM Indígenas 6-23 Meses",
          "Total Niños MAM Indígenas 6-23 Meses",
          "Total Niñas MAM Indígenas 24-59 Meses",
          "Total Niños MAM Indígenas 24-59 Meses",
          "Total Niñas con Sobrepeso y Discapacidad 6-23 Meses",
          "Total Niños con Sobrepeso y Discapacidad 6-23 Meses",
          "Total Niñas con Sobrepeso y Discapacidad 24-59 Meses",
          "Total Niños con Sobrepeso y Discapacidad 24-59 Meses",
          "Total Niñas con Obesidad y Discapacidad 6-23 Meses",
          "Total Niños con Obesidad y Discapacidad 6-23 Meses",
          "Total Niñas con Obesidad y Discapacidad 24-59 Meses",
          "Total Niños con Obesidad y Discapacidad 24-59 Meses",
          "Total Niñas con Sobrepeso 6-23 Meses",
          "Total Niños con Sobrepeso 6-23 Meses",
          "Total Niñas con Sobrepeso 24-59 Meses",
          "Total Niños con Sobrepeso 24-59 Meses",
          "Total Niñas con Obesidad 6-23 Meses",
          "Total Niños con Obesidad 6-23 Meses",
          "Total Niñas con Obesidad 24-59 Meses",
          "Total Niños con Obesidad 24-59 Meses",
          "Total Niñas con Sobrepeso Indígenas 6-23 Meses",
          "Total Niños con Sobrepeso Indígenas 6-23 Meses",
          "Total Niñas con Sobrepeso Indígenas 24-59 Meses",
          "Total Niños con Sobrepeso Indígenas 24-59 Meses",
          "Total Niñas con Obesidad Indígenas 6-23 Meses",
          "Total Niños con Obesidad Indígenas 6-23 Meses",
          "Total Niñas con Obesidad Indígenas 24-59 Meses",
          "Total Niños con Obesidad Indígenas 24-59 Meses",
          "Total Niñas Desparasitadas 6-23 Meses",
          "Total Niños Desparasitados 6-23 Meses",
          "Total Niñas Desparasitadas 24-59 Meses",
          "Total Niños Desparasitados 24-59 Meses",
          "Total SAM Desparasitados",
          "Total MAM Desparasitados",
          "Total SAM Indígenas",
          "Total MAM Indígenas",
          "Total SAM/MAM Escolarizados",
          "Total SAM/MAM Registrados",
          "Total Referidos",
          "RUTF (SAM)",
          "RUTF (MAM)",
          "Total Cajas Micronutrientes (NNA)",
        ],
        data: dataConsolidadoNinos,
      },
      {
        sheetName: "MEL",
        headers: [
          "Municipio",
          "Parroquia",
          "Comunidad",
          "Total MEL",
          "Gestantes Mayores de 18 años",
          "Gestantes Menores de 18 años",
          "Lactantes Mayores de 18 años",
          "Lactantes Menores de 18 años",
          "Gestantes Mayores de 18 años (Bajo Peso)",
          "Gestantes Menores de 18 años (Bajo Peso)",
          "Lactantes Mayores de 18 años (Bajo Peso)",
          "Lactantes Menores de 18 años (Bajo Peso)",
          "Población Indígena",
          "MEL Menores de 18 años Indígenas (Bajo Peso)",
          "MEL Mayores de 18 años Indígenas (Bajo Peso)",
          "MEL Menores de 18 años Desparasitadas",
          "MEL Mayores de 18 años Desparasitadas",
          "LNS-MQ (Cajas)",
        ],
        data: dataConsolidadoMel,
      },
      // Puedes agregar más conjuntos de datos aquí
    ];

    const wb = XLSX.utils.book_new();

    dataSets.forEach((dataSet) => {
      const ws = XLSX.utils.json_to_sheet([]); // Inicializamos una hoja vacía

      // Agregamos los encabezados en la primera fila
      XLSX.utils.sheet_add_aoa(ws, [dataSet.headers], { origin: "A1" });

      // Agregamos los datos JSON, comenzando en la segunda fila ('A2')
      // y sin omitir la cabecera (ya la agregamos manualmente)
      XLSX.utils.sheet_add_json(ws, dataSet.data, {
        origin: "A2",
        skipHeader: true,
      });

      XLSX.utils.book_append_sheet(wb, ws, dataSet.sheetName);
    });

    XLSX.writeFile(
      wb,
      `ESTADISTICAS GENERALES - ${new Date().toLocaleDateString("en-GB")}.xlsx`
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Exportar Tabla
  function handleDownloadExcelM5(rows) {
    /*let tableData = rows.map((row) => Object.values(row.original));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index].splice(-62, 54);
    }*/
    const tableData = rows.map((row) => [
      row.original.estado,
      row.original.municipio,
      row.original.parroquia,
      row.original.centro,
      row.original.comunidad,
      row.original.grupo_etnico,
      row.original.cedula,
      row.original.nombre_rep,
      row.original.telefono_rep,
      row.original.nombre,
      row.original.apellido,
      row.original.sexo,
      row.original.fecha_nacimiento,
      row.original.fecha_evaluacion,
      row.original.edad,
      row.original.registrado,
      row.original.escolaridad,
      row.original.lactancia,
      row.original.veces,
      row.original.biberon,
      row.original.otros_alimentos,
      row.original.agua_hervida,
      row.original.agua_filtrada,
      row.original.agua_sintratar,
      row.original.gripe_tos,
      row.original.fiebre,
      row.original.diarrea,
      row.original.vomito,
      row.original.paludismo_malaria,
      row.original.discapacidad,
      row.original.tipoDiscapacidad,
      row.original.edema,
      row.original.circuenferencia,
      row.original.clasificacion_pb,
      row.original.peso,
      row.original.talla,
      row.original.puntaje_z,
      row.original.clasificacion_nut,
      row.original.puntajeZ_talla,
      row.original.clasificacion_talla,
      row.original.diagnostico_ingreso,
      row.original.consejeria,
      row.original.referido,
      row.original.albendazol,
      row.original.micronutrientes,
      row.original.lns_mq,
      row.original.ruft,
      row.original.kitH,
      row.original.kitR,
      row.original.amoxicilina,
      row.original.medicamentos,
      row.original.dosis_albendazol,
      row.original.dosis_medicamento,
      row.original.observaciones,
      row.original.medico,
    ]);
    const tableHeaders = columns.map((c) => c.header);
    downloadExcel({
      fileName: `Base de Datos - Niños Menores de 5 Años ${new Date().toLocaleDateString(
        "en-GB"
      )}`,
      sheet: "Niños Menores de 5 Años",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelMel(rows) {
    const tableData = rows.map((row) => Object.values(row.original));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index].splice(-48, 40);
    }
    const tableHeaders = columnsMel.map((c) => c.header);
    downloadExcel({
      fileName: `Base de Datos - MEL ${new Date().toLocaleDateString("en-GB")}`,
      sheet: "MEL",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelDesp(rows) {
    const tableData = rows.map((row) => Object.values(row.original));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index].splice(-17, 11);
    }
    const tableHeaders = columnsDesp.map((c) => c.header);
    downloadExcel({
      fileName: `Base de Datos - Desparasitaciones ${new Date().toLocaleDateString(
        "en-GB"
      )}`,
      sheet: "Desparasitaciones",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelCap(rows) {
    const tableData = rows.map((row) => Object.values(row.original));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index].splice(-22, 16);
    }
    const tableHeaders = columnsCap.map((c) => c.header);
    downloadExcel({
      fileName: `Base de Datos - Capacitaciones ${new Date().toLocaleDateString(
        "en-GB"
      )}`,
      sheet: "Capacitaciones",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelRef(rows) {
    let tableData = rows.map((row) => Object.values(row.original));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index].splice(-62, 54);
    }
    const tableHeaders = columns.map((c) => c.header);
    downloadExcel({
      fileName: `Base de Datos - Referidos ${new Date().toLocaleDateString(
        "en-GB"
      )}`,
      sheet: "Referidos",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelConsolidado() {
    let ninofiltro = dataConsolidadoNinos;
    let melfiltro = dataConsolidadoMel;
    for (let index = 0; index < ninofiltro.length; index++) {
      for (let j = 0; j < melfiltro.length; j++) {
        if (ninofiltro[index].comunidad === melfiltro[j].comunidad) {
          ninofiltro[index].totalMel = melfiltro[j]["count(*)"];
          ninofiltro[index].mayoresGestante = melfiltro[j].mayoresGestante;
          ninofiltro[index].menoresGestante = melfiltro[j].menoresGestante;
          ninofiltro[index].mayoresLactantes = melfiltro[j].mayoresLactantes;
          ninofiltro[index].menoresLactantes = melfiltro[j].menoresLactantes;
          ninofiltro[index].mayoresBajoGestante =
            melfiltro[j].mayoresBajoGestante;
          ninofiltro[index].menoresBajoGestante =
            melfiltro[j].menoresBajoGestante;
          ninofiltro[index].mayoresBajoLactantes =
            melfiltro[j].mayoresBajoLactantes;
          ninofiltro[index].menoresBajoLactantes =
            melfiltro[j].menoresBajoLactantes;
          ninofiltro[index].poblacionIndigenaMel =
            melfiltro[j].poblacionIndigena;
          /*ninofiltro[index].MenoresBajoIndigenas =
            melfiltro[j].menoresBajoIndi;
           ninofiltro[index].MayoresBajoIndigenas =
            melfiltro[j].mayoresBajoIndi;
          ninofiltro[index].MenoresDesparasitas =
            melfiltro[j].menoresDespa; 
          ninofiltro[index].MayoresDesparasitas =
            melfiltro[j].mayoresDEspa;*/
          ninofiltro[index].cajasMicroMel = melfiltro[j].cajasMicro;
        }
      }
    }
    console.log(ninofiltro);
    const tableData = ninofiltro.map((row) => Object.values(row));
    for (let index = 0; index < tableData.length; index++) {
      tableData[index] = tableData[index];
    }
    const tableHeaders = columnsConsolidado.map((c) => c.header);
    downloadExcel({
      fileName: `Estadísticas Generales - ${new Date().toLocaleDateString(
        "en-GB"
      )}`,
      sheet: "Estadísticas",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  function handleDownloadExcelSalud(rows) {
    const tableData = rows.map((row) => [
      row.original.estado,
      row.original.municipio,
      row.original.parroquia,
      row.original.centro,
      row.original.fecha_evaluacion,
      row.original.codigo,
      row.original.nombre,
      row.original.apellido,
      row.original.sexo,
      row.original.genero,
      row.original.cedula,
      row.original.telefono,
      row.original.fecha_nacimiento,
      row.original.edad,
      row.original.nombre_rep,
      row.original.apellido_rep,
      row.original.lgbtqi,
      row.original.comunidad,
      row.original.nombre_grupo_etnico,
      row.original.nombre_discapacidad,
      row.original.nombre_movilidad,
      row.original.nombres_factores_riesgo,
      row.original.nombre_nivel_educativo,
      row.original.cabeza_familia,
      row.original.peso,
      row.original.ingresos,
      row.original.motivos_consulta,
      row.original.diagnosticos,
      row.original.nombres_tipos_enfermedad,
      row.original.tratamientosSin,
      row.original.medico,
      row.original.comentarios,
    ]);

    const tableHeaders = columnsSaludConsolidado.map((c) => c.header);
    downloadExcel({
      fileName: `ATENCION MEDICA PRIMARIA - COMPLETO (${new Date().toLocaleDateString(
        "en-GB"
      )})`,
      sheet: "BD - AMP",
      tablePayload: {
        header: tableHeaders,
        body: tableData,
      },
    });
  }

  useEffect(() => {
    if (comunidad === "") {
      setExpanded(false);
    } else {
      setExpanded(false);
      setTimeout(() => {
        setExpanded(true);
      }, 900);
    }
  }, [comunidad]);

  //BreadCrumbs
  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //Routes
  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };
  const handleLinkTrans = (event, message) => {
    if (message === "trans") {
      nav("/transcripcion");
    }
  };

  ////////////////////////////// ARRAYS TABLAS ///////////////////////////////////////
  const columns = useMemo(
    () => [
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "centro",
        header: "Centro de Salud",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "grupo_etnico",
        header: "Grupo Etnico",
      },
      /*{
        accessorKey: "tipo_ingreso",
        header: "Tipo de Ingreso",
      },*/
      {
        accessorKey: "cedula",
        header: "Cédula del Representante",
      },
      {
        accessorKey: "nombre_rep",
        header: "Nombre del Representante",
      },
      {
        accessorKey: "telefono_rep",
        header: "Teléfono del Representante",
      },
      {
        accessorKey: "nombre",
        header: "Nombres del Beneficiario",
      },
      {
        accessorKey: "apellido",
        header: "Apellidos del Beneficiario",
      },
      {
        accessorKey: "sexo",
        header: "Género",
      },
      {
        accessorKey: "fecha_nacimiento",
        header: "Fecha de Nacimiento",
      },
      {
        accessorKey: "fecha_evaluacion",
        header: "Fecha de Evaluación",
      },
      {
        accessorKey: "edad",
        header: "Edad en Meses",
      },
      {
        accessorKey: "registrado",
        header: "Registrado",
      },
      {
        accessorKey: "escolaridad",
        header: "Escolaridad",
      },
      {
        accessorKey: "lactancia",
        header: "¿Recibe Lactancia Materna?",
      },
      {
        accessorKey: "veces",
        header: "¿Cuántas veces al día?",
      },
      {
        accessorKey: "biberon",
        header: "¿Usa Biberón?",
      },
      {
        accessorKey: "otros_alimentos",
        header: "Otros Alimentos",
      },
      {
        accessorKey: "agua_hervida",
        header: "Agua Hervida",
      },
      {
        accessorKey: "agua_filtrada",
        header: "Agua Filtrada o Clorada",
      },
      {
        accessorKey: "agua_sintratar",
        header: "Agua sin Tratamiento",
      },
      {
        accessorKey: "gripe_tos",
        header: "Gripe o Tos en la Última Semana",
      },
      {
        accessorKey: "fiebre",
        header: "Fiebre en la Última Semana",
      },
      {
        accessorKey: "diarrea",
        header: "Diarrea",
      },
      {
        accessorKey: "vomito",
        header: "Vómito",
      },
      {
        accessorKey: "paludismo_malaria",
        header: "Paludismo o Malaria",
      },
      {
        accessorKey: "discapacidad",
        header: "Discapacidad",
      },
      {
        accessorKey: "tipoDiscapacidad",
        header: "¿Cúal?",
      },
      {
        accessorKey: "edema",
        header: "Edema",
      },
      {
        accessorKey: "circunferencia",
        header: "Circunferencia de Brazo (CMB)",
      },
      {
        accessorKey: "clasificacion_pb",
        header: "Clasificación PB",
      },
      {
        accessorKey: "peso",
        header: "Peso (Kg)",
      },
      {
        accessorKey: "talla",
        header: "Talla (cm)",
      },
      {
        accessorKey: "puntaje_z",
        header: "Puntaje Z",
      },
      {
        accessorKey: "clasificacion_nut",
        header: "Clasificación Nutricional",
      },
      {
        accessorKey: "puntajeZ_talla",
        header: "Puntaje Z (Talla para la Edad)",
      },
      {
        accessorKey: "clasificacion_talla",
        header: "Clasificación Talla para la Edad",
      },
      {
        accessorKey: "diagnostico_ingreso",
        header: "Diagnostico de Ingreso",
      },
      {
        accessorKey: "consejeria",
        header: "Consejería en Prácticas Clave",
      },
      {
        accessorKey: "referido",
        header: "Referido",
      },
      {
        accessorKey: "albendazol",
        header: "Albendazol",
      },
      {
        accessorKey: "micronutrientes",
        header: "Micronutrientes",
      },
      {
        accessorKey: "lns_mq",
        header: "LNS-MQ (Sobre Amarillo)",
      },
      {
        accessorKey: "ruft",
        header: "RUTF (Sobre Rojo)",
      },
      {
        accessorKey: "kitH",
        header: "Kit de Higiene",
      },
      {
        accessorKey: "kitR",
        header: "Kit de Reposición",
      },
      {
        accessorKey: "amoxicilina",
        header: "Amoxicilina",
      },
      {
        accessorKey: "medicamentos",
        header: "Medicamentos",
      },
      {
        accessorKey: "dosis_albendazol",
        header: "Dosis Albendazol",
      },
      {
        accessorKey: "dosis_medicamento",
        header: "Dosis de Suplemento Nutricional",
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
      },
      {
        accessorKey: "medico",
        header: "Médico Tratante",
      },
    ],
    []
  );

  const columnsMel = useMemo(
    () => [
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "centro_atencion",
        header: "Centro de Salud",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "grupo_etnico",
        header: "Grupo Etnico",
      },
      {
        accessorKey: "tipo_ingreso",
        header: "Tipo Ingreso",
      },
      {
        accessorKey: "cedula",
        header: "Cédula",
      },
      {
        accessorKey: "nombre",
        header: "Nombres",
      },
      {
        accessorKey: "apellido",
        header: "Apellidos",
      },
      {
        accessorKey: "telefono",
        header: "Teléfono",
      },
      {
        accessorKey: "fecha_nacimiento",
        header: "Fecha de Nacimiento",
      },
      {
        accessorKey: "gestante",
        header: "Gestante",
      },
      {
        accessorKey: "semana_gestacion",
        header: "Semanas de Gestación",
      },
      {
        accessorKey: "peso",
        header: "Peso (Kg)",
      },
      {
        accessorKey: "talla",
        header: "Talla (cm)",
      },
      {
        accessorKey: "lactancia",
        header: "Lactancia",
      },
      {
        accessorKey: "edema",
        header: "Edema",
      },
      {
        accessorKey: "criterio",
        header: "Criterio Médico",
      },
      {
        accessorKey: "fecha_evaluacion",
        header: "Fecha de Valoración",
      },
      {
        accessorKey: "edad",
        header: "Edad en Años",
      },
      {
        accessorKey: "circunferencia_brazo",
        header: "Circunferencia de Brazo (CMB)",
      },
      {
        accessorKey: "clasifiacion_pb",
        header: "Clasificación PB",
      },
      {
        accessorKey: "imc",
        header: "IMC",
      },
      {
        accessorKey: "diagnostico_imc",
        header: "Diagnostico IMC",
      },
      {
        accessorKey: "diagnostico_ingreso",
        header: "Diagnostico Ingreso",
      },
      {
        accessorKey: "diagnostico_gestacion",
        header: "Diagnostico IMC por semanas de gestación",
      },
      {
        accessorKey: "consejeria",
        header: "Consejería en lactancia y alimentación del niño pequeño",
      },
      {
        accessorKey: "referido",
        header: "Referido",
      },
      {
        accessorKey: "albendazol",
        header: "Albendazol",
      },

      {
        accessorKey: "micronutrientes",
        header: "Micronutrientes",
      },
      {
        accessorKey: "lsnmq",
        header: "LNS-MQ",
      },
      {
        accessorKey: "plumpy",
        header: "Plumpy'Mum",
      },
      {
        accessorKey: "kitH",
        header: "Kit de Higiene",
      },
      {
        accessorKey: "kitR",
        header: "kit de Reposición",
      },
      {
        accessorKey: "medicamentos",
        header: "Medicamentos",
      },
      {
        accessorKey: "dosis_albendazol",
        header: "Dosis Albendazol",
      },
      {
        accessorKey: "dosis_medicamento",
        header: "Dosis Medicamento",
      },
      {
        accessorKey: "observaciones",
        header: "Observaciones",
      },
      {
        accessorKey: "medico",
        header: "Médico Tratante",
      },
    ],
    []
  );

  const columnsDesp = useMemo(
    () => [
      {
        accessorKey: "fecha_inr",
        header: "Fecha Inicio del Reporte",
      },
      {
        accessorKey: "fecha_finr",
        header: "Fecha Final del Reporte",
      },
      {
        accessorKey: "nombre_centro",
        header: "Centro de Salud",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "ninos_desparacitados",
        header: "Total de Niños Desparasitados",
      },
      {
        accessorKey: "ninas_desparacitadas",
        header: "Total de Niñas Desparasitadas",
      },
      {
        accessorKey: "escolarizados",
        header: "Escolarizados",
      },
      {
        accessorKey: "equipo",
        header: "Equipo",
      },
    ],
    []
  );

  const columnsCap = useMemo(
    () => [
      {
        accessorKey: "fecha_inr",
        header: "Fecha Inicio",
      },
      {
        accessorKey: "fecha_finr",
        header: "Fecha Final",
      },
      {
        accessorKey: "nombre_centro",
        header: "Centro de Salud",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "hombres17",
        header: "Hombres de 0-17 años",
      },
      {
        accessorKey: "mujeres17",
        header: "Mujeres de 0-17 años",
      },
      {
        accessorKey: "hombres59",
        header: "Hombres de 18-59 años",
      },
      {
        accessorKey: "mujeres59",
        header: "Mujeres de 18-59 años",
      },
      {
        accessorKey: "hombres60",
        header: "Hombres de 60 años o más",
      },
      {
        accessorKey: "mujeres60",
        header: "Mujeres de 60 años o más",
      },
      {
        accessorKey: "total",
        header: "Total Capacitados",
      },
      {
        accessorKey: "total_Lgtbq",
        header: "Personas LGBTQI+",
      },
      {
        accessorKey: "equipo",
        header: "Equipo",
      },
    ],
    []
  );

  const columnsConsolidado = useMemo(
    () => [
      {
        header: "Municipio",
      },
      {
        header: "Parroquia",
      },
      {
        header: "Comunidad",
      },
      {
        header: "Total de Tamizados",
      },
      {
        header: "Total Niñas",
      },
      {
        header: "Total Niños",
      },
      {
        header: "Niñas de 6 a 23 meses",
      },
      {
        header: "Niños de 6 a 23 meses",
      },

      {
        header: "Niñas de 24 a 59 meses",
      },
      {
        header: "Niños de 24 a 59 meses",
      },
      {
        header: "Niñas de 6 a 23 meses (SAM)",
      },
      {
        header: "Niños de 6 a 23 meses (SAM)",
      },
      {
        header: "Niñas de 24 a 59 meses (SAM)",
      },
      {
        header: "Niños de 24 a 59 meses (SAM)",
      },
      {
        header: "Niñas de 6 a 23 meses (MAM)",
      },
      {
        header: "Niños de 6 a 23 meses (MAM)",
      },
      {
        header: "Niñas de 24 a 59 meses (MAM)",
      },
      {
        header: "Niños de 24 a 59 meses (MAM)",
      },
      {
        header: "Niñas de 6 a 23 meses (Adecuado)",
      },
      {
        header: "Niños de 6 a 23 meses (Adecuado)",
      },
      {
        header: "Niñas de 24 a 59 meses (Adecuado)",
      },
      {
        header: "Niños de 24 a 59 meses (Adecuado)",
      },
      {
        header: "Niñas de 6 a 23 meses (Micronutrientes)",
      },
      {
        header: "Niños de 6 a 23 meses (Micronutrientes)",
      },
      {
        header: "Niñas de 24 a 59 meses (Micronutrientes)",
      },
      {
        header: "Niños de 24 a 59 meses (Micronutrientes)",
      },
      {
        header: "Niñas de 6 a 23 meses (PA)",
      },
      {
        header: "Niños de 6 a 23 meses (PA)",
      },
      {
        header: "Niñas de 24 a 59 meses (PA)",
      },
      {
        header: "Niños de 24 a 59 meses (PA)",
      },
      {
        header: "Total PA",
      },
      {
        header: "Total Adecuado",
      },
      {
        header: "Total Puntaje Z entre -2 y -1",
      },
      {
        header: "Población Indígena (NNA)",
      },
      {
        header: "Discapacitados (NNA)",
      },
      {
        header: "Total SAM",
      },
      {
        header: "Total MAM",
      },
      {
        header: "Total Sobrepeso",
      },
      {
        header: "Total Obesidad",
      },
      {
        header: "Total Niñas Adecuadas con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niños Adecuadas con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niñas Adecuadas con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niños Adecuados con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niñas SAM con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niños SAM con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niñas SAM con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niños SAM con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niñas MAM con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niños MAM con Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niñas MAM con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niños MAM con Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niñas Adecuadas Indígenas 6-23 Meses",
      },
      {
        header: "Total Niños Adecuados Indígenas 6-23 Meses",
      },
      {
        header: "Total Niñas Adecuadas Indígenas 24-59 Meses",
      },
      {
        header: "Total Niños Adecuados Indígenas 24-59 Meses",
      },
      {
        header: "Total Niñas SAM Indígenas 6-23 Meses",
      },
      {
        header: "Total Niños SAM Indígenas 6-23 Meses",
      },
      {
        header: "Total Niñas MAM Indígenas 24-59 Meses",
      },
      {
        header: "Total Niños MAM Indígenas 24-59 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso y Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niños con Sobrepeso y Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso y Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niños con Sobrepeso y Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niñas con Obesidad y Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niños con Obesidad y Discapacidad 6-23 Meses",
      },
      {
        header: "Total Niñas con Obesidad y Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niños con Obesidad y Discapacidad 24-59 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso 6-23 Meses",
      },
      {
        header: "Total Niños con Sobrepeso 6-23 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso 24-59 Meses",
      },
      {
        header: "Total Niños con Sobrepeso 24-59 Meses",
      },
      {
        header: "Total Niñas con Obesidad 6-23 Meses",
      },
      {
        header: "Total Niños con Obesidad 6-23 Meses",
      },
      {
        header: "Total Niñas con Obesidad 24-59 Meses",
      },
      {
        header: "Total Niños con Obesidad 24-59 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso Indígenas 6-23 Meses",
      },
      {
        header: "Total Niños con Sobrepeso Indígenas 6-23 Meses",
      },
      {
        header: "Total Niñas con Sobrepeso Indígenas 24-59 Meses",
      },
      {
        header: "Total Niños con Sobrepeso Indígenas 24-59 Meses",
      },
      {
        header: "Total Niñas con Obesidad Indígenas 6-23 Meses",
      },
      {
        header: "Total Niños con Obesidad Indígenas 6-23 Meses",
      },
      {
        header: "Total Niñas con Obesidad Indígenas 24-59 Meses",
      },
      {
        header: "Total Niños con Obesidad Indígenas 24-59 Meses",
      },
      {
        header: "Total Niñas Desparasitadas 6-23 Meses",
      },
      {
        header: "Total Niños Desparasitados 6-23 Meses",
      },
      {
        header: "Total Niñas Desparasitadas 24-59 Meses",
      },
      {
        header: "Total Niños Desparasitados 24-59 Meses",
      },
      {
        header: "Total SAM Desparasitados",
      },
      {
        header: "Total MAM Desparasitados",
      },
      {
        header: "Total SAM Indígenas",
      },
      {
        header: "Total MAM Indígenas",
      },
      {
        header: "Total SAM/MAM Escolarizados",
      },
      {
        header: "Total SAM/MAM Registrados",
      },
      {
        header: "Total Referidos",
      },
      {
        header: "RUTF (SAM)",
      },
      {
        header: "RUTF (MAM)",
      },
      {
        header: "Total Cajas Micronutrientes (NNA)",
      },
      {
        header: "Total MEL",
      },
      {
        header: "Gestantes Mayores de 18 años",
      },
      {
        header: "Gestantes Menores de 18 años",
      },
      {
        header: "Lactantes Mayores de 18 años",
      },
      {
        header: "Lactantes Menores de 18 años",
      },
      {
        header: "Gestantes Mayores de 18 años (Bajo Peso)",
      },
      {
        header: "Gestantes Menores de 18 años (Bajo Peso)",
      },
      {
        header: "Lactantes Mayores de 18 años (Bajo Peso)",
      },
      {
        header: "Lactantes Menores de 18 años (Bajo Peso)",
      },
      {
        header: "Población Indígena (MEL)",
      },
      {
        header: "MEL Menores de 18 años Indígenas (Bajo Peso)",
      },
      {
        header: "MEL Mayores de 18 años Indígenas (Bajo Peso)",
      },
      {
        header: "MEL Menores de 18 años Desparasitadas",
      },
      {
        header: "MEL Mayores de 18 años Desparasitadas",
      },
      {
        header: "LNS-MQ (Cajas)",
      },
    ],
    []
  );

  const columnsSalud = useMemo(
    () => [
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "nombre",
        header: "Primer Nombre",
      },
      {
        accessorKey: "apellido",
        header: "Primer Apellido",
      },
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "centro",
        header: "Comunidad",
      },
      {
        accessorKey: "fecha_evaluacion",
        header: "Fecha de Atención",
      },
      {
        accessorKey: "sexo",
        header: "Sexo",
      },
      {
        accessorKey: "genero",
        header: "Género",
      },
      {
        accessorKey: "cedula",
        header: "Cédula de Identidad",
      },
      {
        accessorKey: "telefono",
        header: "Teléfono",
      },
      {
        accessorKey: "fecha_nacimiento",
        header: "Fecha de Nacimiento",
      },
      {
        accessorKey: "edad",
        header: "Edad",
      },
      {
        accessorKey: "nombre_rep",
        header: "Nombre Representante",
      },
      {
        accessorKey: "apellido_rep",
        header: "Apellido Representante",
      },
      {
        accessorKey: "lgbtqi",
        header: "LGBTQI+",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "nombre_grupo_etnico",
        header: "Grupo Etnico",
      },
      {
        accessorKey: "nombre_discapacidad",
        header: "Discapacidad",
      },
      {
        accessorKey: "nombre_movilidad",
        header: "Condición Movilidad",
      },
      {
        accessorKey: "nombres_factores_riesgo",
        header: "Factores de Riesgo",
      },
      {
        accessorKey: "nombre_nivel_educativo",
        header: "Nivel Educativo",
      },
      {
        accessorKey: "cabeza_familia",
        header: "Cabeza de Familia",
      },
      {
        accessorKey: "peso",
        header: "Peso (Kg)",
      },
      {
        accessorKey: "ingresos",
        header: "Ingresos Propios",
      },
      {
        accessorKey: "motivos_consulta",
        header: "Motivo de Consulta",
      },
      {
        accessorKey: "diagnosticos",
        header: "Diagnóstico",
      },
      {
        accessorKey: "nombres_tipos_enfermedad",
        header: "Tipo de Enfermedad",
      },
      {
        accessorKey: "tratamientosSin",
        header: "Tratamiento",
      },
      {
        accessorKey: "medico",
        header: "Médico Responsable",
      },
      {
        accessorKey: "comentarios",
        header: "Comentarios",
      },
    ],
    []
  );

  const columnsSaludConsolidado = useMemo(
    () => [
      {
        accessorKey: "estado",
        header: "Estado",
      },
      {
        accessorKey: "municipio",
        header: "Municipio",
      },
      {
        accessorKey: "parroquia",
        header: "Parroquia",
      },
      {
        accessorKey: "centro",
        header: "Comunidad",
      },
      {
        accessorKey: "fecha_evaluacion",
        header: "Fecha de Atención",
      },
      {
        accessorKey: "codigo",
        header: "Código",
      },
      {
        accessorKey: "nombre",
        header: "Primer Nombre",
      },
      {
        accessorKey: "apellido",
        header: "Primer Apellido",
      },
      {
        accessorKey: "sexo",
        header: "Sexo",
      },
      {
        accessorKey: "genero",
        header: "Género",
      },
      {
        accessorKey: "cedula",
        header: "Cédula de Identidad",
      },
      {
        accessorKey: "telefono",
        header: "Teléfono",
      },
      {
        accessorKey: "fecha_nacimiento",
        header: "Fecha de Nacimiento",
      },
      {
        accessorKey: "edad",
        header: "Edad",
      },
      {
        accessorKey: "nombre_rep",
        header: "Nombre Representante",
      },
      {
        accessorKey: "apellido_rep",
        header: "Apellido Representante",
      },
      {
        accessorKey: "lgbtqi",
        header: "LGBTQI+",
      },
      {
        accessorKey: "comunidad",
        header: "Comunidad",
      },
      {
        accessorKey: "nombre_grupo_etnico",
        header: "Grupo Etnico",
      },
      {
        accessorKey: "nombre_discapacidad",
        header: "Discapacidad",
      },
      {
        accessorKey: "nombre_movilidad",
        header: "Condición Movilidad",
      },
      {
        accessorKey: "nombres_factores_riesgo",
        header: "Factores de Riesgo",
      },
      {
        accessorKey: "nombre_nivel_educativo",
        header: "Nivel Educativo",
      },
      {
        accessorKey: "cabeza_familia",
        header: "Cabeza de Familia",
      },
      {
        accessorKey: "peso",
        header: "Peso (Kg)",
      },
      {
        accessorKey: "ingresos",
        header: "Ingresos Propios",
      },
      {
        accessorKey: "motivos_consulta",
        header: "Motivo de Consulta",
      },
      {
        accessorKey: "diagnosticos",
        header: "Diagnóstico",
      },
      {
        accessorKey: "nombres_tipos_enfermedad",
        header: "Tipo de Enfermedad",
      },
      {
        accessorKey: "tratamientosSin",
        header: "Tratamiento",
      },
      {
        accessorKey: "medico",
        header: "Médico Responsable",
      },
      {
        accessorKey: "comentarios",
        header: "Comentarios",
      },
    ],
    []
  );

  const [ejecutar, setEjecutar] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [dataSalud, setDataSalud] = React.useState([]);
  const [dataReferidos, setDataReferidos] = React.useState([]);
  const [dataMel, setDataMel] = React.useState([]);
  const [dataDesp, setDataDesp] = React.useState([]);
  const [dataCap, setDataCap] = React.useState([]);
  const [dataConsolidadoNinos, setDataConsolidadoNinos] = React.useState([]);
  const [dataConsolidadoMel, setDataConsolidadoMel] = React.useState([]);

  const [dataComunidades, setDataComunidad] = React.useState([]);

  const ninosCinco = async () => {
    try {
      const { data1 } = await axios
        .get("/todosninos/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setData(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const beneficiarioSalud = async () => {
    try {
      const { data1 } = await axios
        .get("/todossalud/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          var datN = response.data;
          var nom = "";
          var nom1 = "";
          var nom2 = "";
          var nom3 = "";
          //console.log(datN[0].equipos)
          for (let k = 0; k < datN.length; k++) {
            datN[k].tratamientosSin = "";
            // datN[k].motivoConsultaSin = "";
            // datN[k].tipo_enfermedadSin = "";
            // datN[k].diagnosticosSin = "";
            // const obj = JSON.parse(datN[k].motivoConsulta);
            // const obj1 = JSON.parse(datN[k].diagnosticos);
            // const obj2 = JSON.parse(datN[k].tipo_enfermedad);
            if (datN[k].peso == "") {
              datN[k].peso = "N/A";
            }
            const obj3 = JSON.parse(datN[k].tratamientos);
            // for (let f = 0; f < obj.length; f++) {
            //   nom = obj[f].motivoConsulta;
            //   datN[k].motivoConsultaSin = datN[k].motivoConsultaSin + ", " + nom;
            // }
            // for (let f = 0; f < obj1.length; f++) {
            //   nom1 = obj1[f].diagnostico;
            //   datN[k].diagnosticosSin = datN[k].diagnosticosSin + ", " + nom1;
            // }
            // for (let f = 0; f < obj2.length; f++) {
            //   nom2 = obj2[f];
            //   datN[k].tipo_enfermedadSin = datN[k].tipo_enfermedadSin + ", " + nom2;
            // }
            for (let f = 0; f < obj3.length; f++) {
              nom3 = obj3[f];
              datN[k].tratamientosSin = datN[k].tratamientosSin + ", " + nom3;
            }
            // datN[k].motivoConsultaSin = datN[k].motivoConsultaSin.slice(1);
            // datN[k].diagnosticosSin = datN[k].diagnosticosSin.slice(1);
            // datN[k].tipo_enfermedadSin = datN[k].tipo_enfermedadSin.slice(1);
            datN[k].tratamientosSin = datN[k].tratamientosSin.slice(1);
          }

          setDataSalud(datN);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const ninosRferidos = async () => {
    try {
      const { data1 } = await axios
        .get("/todosReferidos/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataReferidos(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const mel = async () => {
    try {
      const { data1 } = await axios
        .get("/todosmel/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataMel(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const desparasitaciones = async () => {
    try {
      const { data1 } = await axios
        .get("/todosdesp/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataDesp(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const Capacitaciones = async () => {
    try {
      const { data1 } = await axios
        .get("/todoscap/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataCap(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const consolidadoNinos = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadoninos/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);

          setDataConsolidadoNinos(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const consolidadoMel = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadomel/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataConsolidadoMel(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const getcomunidades = async () => {
    try {
      const { data1 } = await axios
        .get("/getcomunidades/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data);
          setDataComunidad(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };

  const consolidadoSaludSexo = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludsexo/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludCon");

          setDataConsolidadoSaludSexo(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log(error);
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadoSaludDiscapacidad = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludsdiscapacidad/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConDis");

          setDataConsolidadoSaludDiscapacidad(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadoSaludMovilidad = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludmovilidad/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConMov");

          setDataConsolidadoSaludMovilidad(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadosaludFactores = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludfactores/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConF");

          setDataConsolidadoSaludFactores(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadosaludEnfermedadesEdades = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludenferdadesedades/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConEnf");

          setDataConsolidadoSaludEnfermedadesEdades(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadosaludEnfermedadesSexos = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludenfermedadessexo/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConEnfs");

          setDataConsolidadoSaludEnfermedadesSexos(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadosaludEdades = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludedades/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConEnfs");

          setDataConsolidadoSaludEdad(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  const consolidadosaludEdadesSexo = async () => {
    try {
      const { data1 } = await axios
        .get("/consolidadosaludedadessexo/", {
          params: {
            id: proyect.idproyectos,
          },
        })
        .then(function (response) {
          // setAlerta({})
          console.log(response.data, "saludConEnfs");

          setDataConsolidadoSaludEdadSexo(response.data);
          setEjecutar(false);
          return;
        })
        .catch(function (error) {
          console.log("error");
          return;
        });
    } catch (error) {
      return;
    }
  };
  if (ejecutar) {
    mel();
    desparasitaciones();
    Capacitaciones();
    ninosCinco();
    ninosRferidos();
    consolidadoNinos();
    consolidadoMel();
    getcomunidades();
    consolidadoSaludSexo();
    consolidadoSaludDiscapacidad();
    consolidadoSaludMovilidad();
    consolidadosaludFactores();
    consolidadosaludEnfermedadesEdades();
    consolidadosaludEnfermedadesSexos();
    consolidadosaludEdades();
    consolidadosaludEdadesSexo();
    beneficiarioSalud();
  }

  //const tipoProyecto = 1;

  return (
    <Box m="1.5rem 2.5rem">
      {rol === "1" ||
      rol === "2" ||
      rol === "6" ||
      rol === "8" ||
      rol === "10" ? (
        <>
          <Box
            role="presentation"
            onClick={handleClickBreadCrumbs}
            sx={{ mb: 3 }}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/inicio"
                onClick={(event) => handleLinkHome(event, "home")}
              >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                Inicio
              </Link>
              <Link
                underline="hover"
                sx={{ display: "flex", alignItems: "center" }}
                color="inherit"
                href="/transcripcion"
                onClick={(event) => handleLinkTrans(event, "trans")}
              >
                <DriveFileRenameOutlineIcon
                  sx={{ mr: 0.5 }}
                  fontSize="inherit"
                />
                Transcripción
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                color="text.primary"
              >
                <StorageOutlined sx={{ mr: 0.5 }} fontSize="inherit" />
                Base de Datos
              </Typography>
            </Breadcrumbs>
            <Typography variant="h3" sx={{ mt: 2 }}>
              <b>Base de Datos: </b> {proyect.nombre}
            </Typography>
          </Box>
          <Box
            mt="10px"
            display="grid"
            gridTemplateColumns="repeat(8, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
              "& > div": {
                gridColumn: isNonMediumScreens ? undefined : "span 12",
              },
            }}
          >
            <Box
              gridColumn="span 3"
              gridRow="span 3"
              p="1.5rem"
              borderRadius="1.5rem"
              mt="10px"
              height="fit-content"
            >
              <Grid container>
                <Grid item xs={12} mt={2}>
                  {/* /////////////////////  CARD ESTADISTICAS NUTRICIÓN  //////////////////// */}
                  <Card
                    sx={{
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: 6,
                      boxShadow: 4,
                    }}
                    hidden={proyect.tipo == 2}
                  >
                    <CardHeader
                      avatar={
                        <Avatar sx={{ bgcolor: "teal", width: 50, height: 50 }}>
                          <BarChart sx={{ color: "white", fontSize: 30 }} />
                        </Avatar>
                      }
                      title="Estadísticas del Proyecto"
                      //subheader="September 14, 2016"
                      titleTypographyProps={{
                        fontWeight: "bold",
                        fontSize: 20,
                      }}
                    />
                    <CardContent>
                      <Typography mb={2}>
                        Puedes exportar las estadísticas del proyecto a{" "}
                        <b>Excel</b>.
                      </Typography>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item sm={6}>
                          <FormControl>
                            <RadioGroup
                              value={exportRadio}
                              onChange={handleExportRadio}
                              row
                            >
                              <FormControlLabel
                                value="general"
                                control={<Radio />}
                                label="General"
                              />
                              <FormControlLabel
                                value="fecha"
                                control={<Radio />}
                                label="Por Fecha"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        {/* /////////////////// EXPORTAR GENERAL  ////////////////////// */}
                        <Grid
                          item
                          sm={11}
                          hidden={exportRadio === "fecha" || exportRadio === ""}
                        >
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            fullWidth
                            //onClick={handleDownloadExcelConsolidado}
                            onClick={handleDownloadConsolidadoNutri}
                          >
                            <FileDownloadIcon sx={{ mr: 1 }} /> Exportar a Excel
                          </Button>
                          {/*<a href="/pdfConsolidado" target="_blank" rel="noreferrer">Test PDF</a>*/}
                        </Grid>
                         {/* ////////////////// EXPORTAR POR FECHA ///////////////////// */}
                        <Grid
                          item
                          sm={11}
                          hidden={
                            exportRadio === "general" || exportRadio === ""
                          }
                        >
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha inicio"
                              name="fechaActividad"
                              inputFormat="DD/MM/YYYY"
                              value={fechaInicio}
                              onChange={setFechaInicio}
                              renderInput={(params) => {
                                return <TextField fullWidth {...params} />;
                              }}
                              clearable
                            />
                          </LocalizationProvider>
                          <Box mt={2} mb={3}>
                            <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha final"
                              name="fechaActividad"
                              inputFormat="DD/MM/YYYY"
                              value={fechaFinal}
                              onChange={setFechaFinal}
                              renderInput={(params) => {
                                return <TextField fullWidth {...params} />;
                              }}
                              clearable
                            />
                          </LocalizationProvider>
                          </Box>
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            fullWidth
                            //onClick={handleDownloadExcelConsolidado}
                            onClick={handleDownloadConsolidadoNutri}
                            disabled={fechaInicio === null || fechaFinal === null }
                          >
                            <FileDownloadIcon sx={{ mr: 1 }} /> Exportar a Excel
                          </Button>
                        </Grid>
                      </Grid>
                       <Divider sx={{ mt: 3, mb: 3 }} />
                       <Typography mb={3}>
                        O puedes seleccionar una comunidad y ver sus estadísticas.
                      </Typography>
                      <Grid container justifyContent="center">
                        <Grid item xs={12} sm={11}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Comunidad
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={comunidad}
                              label="Comunidad"
                              onChange={handleSelect}
                            >
                              <MenuItem value={""}>
                                <em>Seleccionar comunidad...</em>
                              </MenuItem>
                              {dataComunidades.map((dat, index) => (
                                <MenuItem value={dat.comunidad}>
                                  {dat.comunidad}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions disableSpacing>
                      <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="ver más"
                        disabled={comunidad === ""}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 35 }} />
                      </ExpandMore>
                    </CardActions>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <CardContent>
                        <Divider>
                          <Chip label="INFO. GENERAL" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography
                                mb={2}
                                className={isSmallScreen ? "text-center" : ""}
                              >
                                <b>Municipio: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].municipio
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography>
                                <b>Parroquia: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].parroquia
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip label="NIÑOS TAMIZADOS" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={1}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninas6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninos6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninas24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninos24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography
                                mt={3}
                                mb={isSmallScreen ? 2 : 0}
                                variant="h5"
                                className={isSmallScreen ? "text-center" : ""}
                              >
                                <b>TOTAL: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0]["count(*)"]
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={1}>
                                <b>Población Indígena: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].poblacionIndigena
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].discapacidad
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Referidos: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].referidos
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip label="SAM" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSevera6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSevera6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSevera24_59
                                  : "Seleccione Comunidad"}
                              </Typography>

                              <Typography mb={1}>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSevera24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalNinos.length > 0
                              ? totalNinos[0].ninoSam
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="MAM" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalNinos.length > 0
                              ? totalNinos[0].ninoMam
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="SOBREPESO" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobre6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobre24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobre6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobre24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobreDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobreDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobreDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobreDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobreIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobreIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasSobreIndige24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosSobreIndige24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalNinos.length > 0
                              ? totalNinos[0].ninoSobrepeso
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="OBESIDAD" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidad6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidad24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidad6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidad24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidadDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidadDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidadDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidadDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidadIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidadIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasObesidadDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosObesidadIndige24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalNinos.length > 0
                              ? totalNinos[0].ninoObesidad
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="PA" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuado6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Femenino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuado24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Masculino 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuado6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuado24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuadoDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuadoDis6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuadoDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses con Discapacidad: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuadoDis24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuadoIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 6-23 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuadoIndige6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Femenino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninasAdecuadoIndige24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Masculino 24-59 Meses (Pob. Indígena): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosAdecuadoIndige24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalNinos.length > 0
                              ? totalNinos[0].ninoAdecuado
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="MEL" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid
                              item
                              sm={6}
                              className={isSmallScreen ? "text-center" : ""}
                            >
                              <Typography mb={1}>
                                <b>Gest. Menores de 18 años: </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].menoresGestante
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={3}>
                                <b>Gest. Mayores de 18 años: </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].mayoresGestante
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={1}>
                                <b>Lac. Menores de 18 años: </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].menoresLactantes
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Lac. Mayores de 18 años: </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].mayoresLactantes
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mt={3}>
                                <b>Gest. Menores de 18 años (Bajo Peso) : </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].menoresBajoGestante
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mt={1}>
                                <b>Gest. Mayores de 18 años (Bajo Peso) : </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].mayoresBajoGestante
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mt={3}>
                                <b>Lac. Menores de 18 años (Bajo Peso) : </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].menoresBajoLactantes
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mt={1}>
                                <b>Lac. Mayores de 18 años (Bajo Peso) : </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].mayoresBajoLactantes
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>Población Indígena: </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].poblacionIndigena
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={2}>
                                <b>
                                  Bajo Peso Menores de 18 años (Pob. Indígena):{" "}
                                </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].poblacionIndigena
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={2}>
                                <b>
                                  Bajo Peso Mayores de 18 años (Pob. Indígena):{" "}
                                </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].poblacionIndigena
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Typography
                            className="text-center"
                            mt={2}
                            variant="h5"
                          >
                            <b>TOTAL: </b>{" "}
                            {totalMel.length > 0
                              ? totalMel[0].totalMel
                              : "Seleccione Comunidad"}
                          </Typography>
                        </Box>
                        <Divider>
                          <Chip label="DESPARASITACIÓN" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>NNA's 6-23 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>MEL Menores de 18 años: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>NNA's 24-59 Meses: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada6_23
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>MEL Mayores de 18 años: </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].ninosModerada24_59
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip label="INSUMOS UTILIZADOS" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent={isSmallScreen ? "center" : ""}
                          >
                            <Grid
                              item
                              sm={6}
                              className={isSmallScreen ? "text-center" : ""}
                            >
                              <Typography mb={1}>
                                <b>RUTF (SAM): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].rutfSam
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography mb={2}>
                                <b>RUTF (MAM): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].rutfMam
                                  : "Seleccione Comunidad"}
                              </Typography>
                              <Typography>
                                <b>Micronutrientes (Cajas): </b>{" "}
                                {totalNinos.length > 0
                                  ? totalNinos[0].cajasMicro
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                            <Grid item sm={6}>
                              <Typography mb={2}>
                                <b>LNS-MQ (Cajas): </b>{" "}
                                {totalMel.length > 0
                                  ? totalMel[0].cajasMicro
                                  : "Seleccione Comunidad"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Collapse>
                  </Card>
                  {/* ///////////////////////  CARD ESTADISTICAS SALUD  ////////////////////// */}
                  <Card
                    sx={{
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: 6,
                      boxShadow: 4,
                    }}
                    hidden={proyect.tipo == 1}
                  >
                    <CardHeader
                      avatar={
                        <Avatar sx={{ bgcolor: "teal", width: 50, height: 50 }}>
                          <BarChart sx={{ color: "white", fontSize: 30 }} />
                        </Avatar>
                      }
                      title="Estadísticas del Proyecto"
                      //subheader="September 14, 2016"
                      titleTypographyProps={{
                        fontWeight: "bold",
                        fontSize: 20,
                      }}
                    />
                    <CardContent>
                      {/*<Typography mb={3}>
                        Selecciona una comunidad para ver sus estadísticas.
                      </Typography>
                      <Grid container justifyContent="center">
                        <Grid item xs={12} sm={11}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Comunidad
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={comunidad}
                              label="Comunidad"
                              onChange={handleSelect}
                            >
                              <MenuItem value={""}>
                                <em>Seleccionar comunidad...</em>
                              </MenuItem>
                              {dataComunidades.map((dat, index) => (
                                <MenuItem value={dat.comunidad}>
                                  {dat.comunidad}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>*/}
                      <Divider sx={{ mt: 3, mb: 3 }} />
                      {/*<Typography mb={2}>
                        También puedes exportar todas las estadísticas a{" "}
                        <b>Excel</b>.
                      </Typography>*/}
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item sm={11}>
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            fullWidth
                            onClick={handleDownloadExcelPrueba}
                          >
                            <FileDownloadIcon sx={{ mr: 1 }} /> Exportar a Excel
                          </Button>
                          {/*<a href="/pdfConsolidado" target="_blank" rel="noreferrer">Test PDF</a>*/}
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions disableSpacing>
                      <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="ver más"
                        //disabled={comunidad === ""}
                      >
                        <ExpandMoreIcon sx={{ fontSize: 35 }} />
                      </ExpandMore>
                    </CardActions>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <CardContent>
                        <Divider>
                          <Chip label="INFO. GENERAL" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            //justifyContent={isSmallScreen ? "center" : ""}
                            justifyContent="center"
                          >
                            <Grid item sm={5}>
                              <Typography>
                                <b>Estado: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Municipio: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Parroquia: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Fecha de Actividad: </b> 01/01/2025
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip label="GRUPOS ETARIOS VS ETNIAS" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>0-5 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Hombre</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Mujer</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Añu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Mestizo</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Wayuu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Yukpa</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>6-19 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Añu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Mestizo</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Wayuu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Yukpa</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>20-64 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Añu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Mestizo</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Wayuu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Yukpa</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>65 años o más</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Añu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Mestizo</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Wayuu</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Yukpa</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography sx={{ bgcolor: "lightgrey" }}>
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip
                            label="GRUPOS ETARIOS VS DISCAPACIDADES"
                            size="small"
                          />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>0-5 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Hombre</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Mujer</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Física</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Intelectual</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Múltiple</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>6-19 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Intelectual</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>20-64 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Física</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>65 años o más</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography sx={{ bgcolor: "lightgrey" }}>
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip
                            label="GRUPOS ETARIOS VS MOVILIDAD"
                            size="small"
                          />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>0-5 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Hombre</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Mujer</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Desplazado Interno</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Pendular</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Retornado</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>6-19 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Intelectual</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>20-64 años</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Física</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                <b>65 años o más</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={6}></Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Sensorial</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography sx={{ bgcolor: "lightgrey" }}>
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip
                            label="CONSOLIDADO FACTOR DE RIESGO"
                            size="small"
                          />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}></Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Hombre</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Mujer</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Abuso emocional o psicológico
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Abuso físico</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Abuso sexual</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Embarazo adolescente</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Explotación sexual</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Falta documentos identidad
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Matrimonio infantil</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Negligencia</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                No acompañado ({"<"}18 años)
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Trabajo infantil</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Trastorno mental</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography sx={{ bgcolor: "lightgrey" }}>
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                        <Divider>
                          <Chip
                            label="CONSOLIDADO TIPO DE ENFERMEDAD"
                            size="small"
                          />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}></Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Hombre</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>Mujer</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Adulto sano</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Algunas enfermedades infecciosas o parasitarias
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Anomalías del desarrollo prenatal
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Condiciones relacionadas con la salud sexual
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Embarazo, parto, puerperio o trastornos
                                hormonales
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades de la piel y anexos
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades de la sangre o de los órganos
                                hematopoyéticos
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades de las glandulas mamarias
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades degenerativas
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del aparato digestivo
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del aparato genitourinario
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del aparato respiratorio
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del ojo y sus anexos
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del oído o de la apófisis mastoides
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del sistema circulatorio o
                                cardiovascular
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del sistema inmunitario
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del sistema musculo esquelético, de
                                los nervios o del tejido conectivo
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades del sistema nervioso
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades endocrinas, nutricionales o
                                metabólicas
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Enfermedades odontologicas
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Factores que influyen en el estado de salud o el
                                contacto con los servicios de salud
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Neoplasias</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>Niño/adolescente sano</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Trastornos mentales, del comportamiento y del
                                neurodesarrollo
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography>
                                Traumatismos, intoxicaciones u otras
                                consecuencias de causas externas de morbilidad o
                                mortalidad
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography className="text-center">0</Typography>
                            </Grid>
                          </Grid>
                          <Divider />
                          <Grid container justifyContent="center">
                            <Grid item xs={5}>
                              <Typography sx={{ bgcolor: "lightgrey" }}>
                                <b>TOTAL</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={2}>
                              <Typography
                                sx={{ bgcolor: "lightgrey" }}
                                className="text-center"
                              >
                                <b>0</b>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Collapse>
                  </Card>
                  {/* //////////////////////  CARD ESTADISTICAS TELEMED  ///////////////////// */}
                  <Card
                    sx={{
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: 6,
                      boxShadow: 4,
                    }}
                    hidden
                  >
                    <CardHeader
                      avatar={
                        <Avatar sx={{ bgcolor: "teal", width: 50, height: 50 }}>
                          <BarChart sx={{ color: "white", fontSize: 30 }} />
                        </Avatar>
                      }
                      title="Estadísticas del Proyecto"
                      titleTypographyProps={{
                        fontWeight: "bold",
                        fontSize: 20,
                      }}
                    />
                    <CardContent>
                      <Divider sx={{ mt: 3, mb: 3 }} />
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item sm={11}>
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            fullWidth
                            onClick={handleDownloadExcelPrueba}
                          >
                            <FileDownloadIcon sx={{ mr: 1 }} /> Exportar a Excel
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions disableSpacing>
                      <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="ver más"
                      >
                        <ExpandMoreIcon sx={{ fontSize: 35 }} />
                      </ExpandMore>
                    </CardActions>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <CardContent>
                        {/* SECCIÓN 1: INFO GENERAL */}
                        <Divider>
                          <Chip label="INFO. GENERAL" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container spacing={1} justifyContent="center">
                            <Grid item sm={5}>
                              <Typography>
                                <b>Estado: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Municipio: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Parroquia: </b> XXXXXXX
                              </Typography>
                            </Grid>
                            <Grid item sm={5}>
                              <Typography>
                                <b>Fecha de Actividad: </b> 01/01/2025
                              </Typography>
                            </Grid>
                            <Grid item sm={10}>
                              <Typography>
                                <b>Total Atendido: </b> XXXXXXX
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* SECCIÓN: INDIGENA */}
                        <Divider>
                          <Chip label="INDIGENA" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Femenino</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Masculino</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Total</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* SECCIÓN: DISCAPACIDAD */}
                        <Divider>
                          <Chip label="DISCAPACIDAD" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid container justifyContent="center" spacing={2}>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Femenino</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Masculino</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                            <Grid item xs={4} sx={{ textAlign: "center" }}>
                              <Typography>
                                <b>Total</b>
                              </Typography>
                              <Typography>0</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* SECCIÓN: GRUPOS ETARIOS */}
                        <Divider>
                          <Chip label="GRUPOS ETARIOS" size="small" />
                        </Divider>
                        <Box mt={3} mb={3}>
                          <Grid
                            container
                            spacing={1}
                            justifyContent="center"
                            rowSpacing={2}
                          >
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Niños 0-11 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Niñas 0-11 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Hombres 12-17 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Mujeres 12-17 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Hombres 18-35 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Mujeres 18-35 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Hombres 36-54 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Mujeres 36-54 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Hombres Mayores de 55 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography>
                                Mujeres Mayores de 55 años: <b>0</b>
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography align="center">
                                <b>Total: 0</b>
                              </Typography>
                              <Divider sx={{ my: 2 }} />
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Collapse>
                  </Card>
                </Grid>
                <Grid
                  item
                  xs={12}
                  mt={2}
                  hidden={isNonMediumScreens || expanded == false}
                >
                  <Card
                    sx={{
                      backgroundColor: theme.palette.background.alt,
                      borderRadius: 6,
                      boxShadow: 4,
                    }}
                  >
                    <CardContent>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={11}>
                          <Button
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            fullWidth
                            onClick={handleViewTable}
                          >
                            <TableViewIcon sx={{ mr: 1 }} /> Ver Tabla
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
            {/* /////////////////////////////////////////////////  TABLA NUTRICIÓN  /////////////////////////////////////////////// */}
            <Box
              gridColumn="span 5"
              gridRow="span 3"
              backgroundColor={theme.palette.background.alt}
              p="1.5rem"
              borderRadius="1.5rem"
              mt="45px"
              height="fit-content"
              sx={{ boxShadow: 4 }}
              hidden={(isSmallScreen && expanded == true) || proyect.tipo == 2}
            >
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    variant={isSmallScreen ? "scrollable" : "fullWidth"}
                    onChange={handleChange}
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="basic tabs example"
                  >
                    <Tab
                      icon={<ChildCareOutlinedIcon />}
                      iconPosition="start"
                      label="Menores de 5 Años"
                      {...a11yProps(0)}
                    />
                    <Tab
                      icon={<PregnantWomanOutlinedIcon />}
                      iconPosition="start"
                      label="MEL"
                      {...a11yProps(1)}
                    />
                    <Tab
                      icon={<MedicationOutlinedIcon />}
                      iconPosition="start"
                      label="Desparasitaciones"
                      {...a11yProps(2)}
                    />
                    <Tab
                      icon={<SchoolIcon />}
                      iconPosition="start"
                      label="Capacitaciones"
                      {...a11yProps(3)}
                    />
                    <Tab
                      icon={<AssignmentLateIcon />}
                      iconPosition="start"
                      label="Referidos"
                      {...a11yProps(4)}
                    />
                    <Tab
                      icon={<HealthAndSafety />}
                      iconPosition="start"
                      label="Salud"
                      {...a11yProps(5)}
                    />
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <MaterialReactTable
                    columns={columns}
                    data={data}
                    localization={MRT_Localization_ES}
                    enableRowSelection
                    enableColumnFilters={false}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelM5(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                        >
                          <FileDownloadIcon />
                        </IconButton>
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelM5(
                              table.getSelectedRowModel().rows
                            )
                          }
                        >
                          <SystemUpdateAlt />
                        </IconButton>
                        <Button
                          color="info"
                          hidden={isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelM5(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                          variant="contained"
                        >
                          <FileDownloadIcon sx={{ mr: 1 }} />
                          Exportar Todo
                        </Button>
                        <Button
                          color="success"
                          hidden={isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelM5(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<SystemUpdateAlt />}
                          variant="contained"
                        >
                          Exportar Selección
                        </Button>
                      </Box>
                    )}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableHeadCellProps={{
                      align: "center",
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableBodyProps={{
                      sx: {
                        "& tr:nth-of-type(odd)": {
                          backgroundColor: theme.palette.background.light,
                        },
                      },
                    }}
                    muiTableBodyCellProps={{
                      align: "center",
                    }}
                    muiTablePaperProps={{
                      elevation: 0,
                    }}
                    initialState={{
                      pagination: {
                        pageSize: 20,
                        pageIndex: 0,
                      },
                    }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                      showFirstButton: false,
                      showLastButton: false,
                      SelectProps: {
                        native: true,
                      },
                      labelRowsPerPage: "Número de filas visibles",
                    }}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <MaterialReactTable
                    columns={columnsMel}
                    data={dataMel}
                    localization={MRT_Localization_ES}
                    enableRowSelection
                    enableColumnFilters={false}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelMel(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                        >
                          <FileDownloadIcon />
                        </IconButton>
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelMel(
                              table.getSelectedRowModel().rows
                            )
                          }
                        >
                          <SystemUpdateAlt />
                        </IconButton>
                        <Button
                          color="info"
                          hidden={isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelMel(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                          variant="contained"
                        >
                          <FileDownloadIcon sx={{ mr: 1 }} />
                          Exportar Todo
                        </Button>
                        <Button
                          color="success"
                          hidden={isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelMel(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<SystemUpdateAlt />}
                          variant="contained"
                        >
                          Exportar Selección
                        </Button>
                      </Box>
                    )}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableHeadCellProps={{
                      align: "center",
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableBodyProps={{
                      sx: {
                        "& tr:nth-of-type(odd)": {
                          backgroundColor: theme.palette.background.light,
                        },
                      },
                    }}
                    muiTableBodyCellProps={{
                      align: "center",
                    }}
                    muiTablePaperProps={{
                      elevation: 0,
                    }}
                    initialState={{
                      pagination: {
                        pageSize: 20,
                        pageIndex: 0,
                      },
                    }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                      showFirstButton: false,
                      showLastButton: false,
                      SelectProps: {
                        native: true,
                      },
                      labelRowsPerPage: "Número de filas visibles",
                    }}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <MaterialReactTable
                    columns={columnsDesp}
                    data={dataDesp}
                    localization={MRT_Localization_ES}
                    enableRowSelection
                    enableColumnFilters={false}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelDesp(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                        >
                          <FileDownloadIcon />
                        </IconButton>
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelDesp(
                              table.getSelectedRowModel().rows
                            )
                          }
                        >
                          <SystemUpdateAlt />
                        </IconButton>
                        <Button
                          color="info"
                          hidden={isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelDesp(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                          variant="contained"
                        >
                          <FileDownloadIcon sx={{ mr: 1 }} />
                          Exportar Todo
                        </Button>
                        <Button
                          color="success"
                          hidden={isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelDesp(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<SystemUpdateAlt />}
                          variant="contained"
                        >
                          Exportar Selección
                        </Button>
                      </Box>
                    )}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableHeadCellProps={{
                      align: "center",
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableBodyProps={{
                      sx: {
                        "& tr:nth-of-type(odd)": {
                          backgroundColor: theme.palette.background.light,
                        },
                      },
                    }}
                    muiTableBodyCellProps={{
                      align: "center",
                    }}
                    muiTablePaperProps={{
                      elevation: 0,
                    }}
                    initialState={{
                      pagination: {
                        pageSize: 20,
                        pageIndex: 0,
                      },
                    }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                      showFirstButton: false,
                      showLastButton: false,
                      SelectProps: {
                        native: true,
                      },
                      labelRowsPerPage: "Número de filas visibles",
                    }}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <MaterialReactTable
                    columns={columnsCap}
                    data={dataCap}
                    localization={MRT_Localization_ES}
                    enableRowSelection
                    enableColumnFilters={false}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelCap(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                        >
                          <FileDownloadIcon />
                        </IconButton>
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelCap(
                              table.getSelectedRowModel().rows
                            )
                          }
                        >
                          <SystemUpdateAlt />
                        </IconButton>
                        <Button
                          color="info"
                          hidden={isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelCap(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                          variant="contained"
                        >
                          <FileDownloadIcon sx={{ mr: 1 }} />
                          Exportar Todo
                        </Button>
                        <Button
                          color="success"
                          hidden={isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelCap(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<SystemUpdateAlt />}
                          variant="contained"
                        >
                          Exportar Selección
                        </Button>
                      </Box>
                    )}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableHeadCellProps={{
                      align: "center",
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableBodyProps={{
                      sx: {
                        "& tr:nth-of-type(odd)": {
                          backgroundColor: theme.palette.background.light,
                        },
                      },
                    }}
                    muiTableBodyCellProps={{
                      align: "center",
                    }}
                    muiTablePaperProps={{
                      elevation: 0,
                    }}
                    initialState={{
                      pagination: {
                        pageSize: 20,
                        pageIndex: 0,
                      },
                    }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                      showFirstButton: false,
                      showLastButton: false,
                      SelectProps: {
                        native: true,
                      },
                      labelRowsPerPage: "Número de filas visibles",
                    }}
                  />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                  <MaterialReactTable
                    columns={columns}
                    data={dataReferidos}
                    localization={MRT_Localization_ES}
                    enableRowSelection
                    enableColumnFilters={false}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelRef(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                        >
                          <FileDownloadIcon />
                        </IconButton>
                        <IconButton
                          hidden={!isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelRef(
                              table.getSelectedRowModel().rows
                            )
                          }
                        >
                          <SystemUpdateAlt />
                        </IconButton>
                        <Button
                          color="info"
                          hidden={isSmallScreen}
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }
                          //export all rows, including from the next page, (still respects filtering and sorting)
                          onClick={() =>
                            handleDownloadExcelRef(
                              table.getPrePaginationRowModel().rows
                            )
                          }
                          variant="contained"
                        >
                          <FileDownloadIcon sx={{ mr: 1 }} />
                          Exportar Todo
                        </Button>
                        <Button
                          color="success"
                          hidden={isSmallScreen}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          //only export selected rows
                          onClick={() =>
                            handleDownloadExcelRef(
                              table.getSelectedRowModel().rows
                            )
                          }
                          startIcon={<SystemUpdateAlt />}
                          variant="contained"
                        >
                          Exportar Selección
                        </Button>
                      </Box>
                    )}
                    muiTopToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableHeadCellProps={{
                      align: "center",
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiBottomToolbarProps={{
                      sx: {
                        backgroundColor: theme.palette.background.alt,
                      },
                    }}
                    muiTableBodyProps={{
                      sx: {
                        "& tr:nth-of-type(odd)": {
                          backgroundColor: theme.palette.background.light,
                        },
                      },
                    }}
                    muiTableBodyCellProps={{
                      align: "center",
                    }}
                    muiTablePaperProps={{
                      elevation: 0,
                    }}
                    initialState={{
                      pagination: {
                        pageSize: 20,
                        pageIndex: 0,
                      },
                    }}
                    muiTablePaginationProps={{
                      rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                      showFirstButton: false,
                      showLastButton: false,
                      SelectProps: {
                        native: true,
                      },
                      labelRowsPerPage: "Número de filas visibles",
                    }}
                  />
                </CustomTabPanel>
              </Box>
            </Box>
            {/* ///////////////////////////////////////////////// TABLA SALUD  /////////////////////////////////////////////////// */}
            <Box
              gridColumn="span 5"
              gridRow="span 3"
              backgroundColor={theme.palette.background.alt}
              p="1.5rem"
              borderRadius="1.5rem"
              mt="45px"
              height="fit-content"
              sx={{ boxShadow: 4 }}
              hidden={(isSmallScreen && expanded == true) || proyect.tipo == 1}
            >
              <Box sx={{ width: "100%" }}>
                <MaterialReactTable
                  columns={columnsSalud}
                  data={dataSalud}
                  localization={MRT_Localization_ES}
                  enableRowSelection
                  enableColumnFilters={false}
                  positionExpandColumn="first"
                  positionActionsColumn="first"
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "16px",
                        padding: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <IconButton
                        hidden={!isSmallScreen}
                        disabled={
                          table.getPrePaginationRowModel().rows.length === 0
                        }
                        //export all rows, including from the next page, (still respects filtering and sorting)
                        onClick={() =>
                          handleDownloadExcelSalud(
                            table.getPrePaginationRowModel().rows
                          )
                        }
                      >
                        <FileDownloadIcon />
                      </IconButton>
                      <IconButton
                        hidden={!isSmallScreen}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleDownloadExcelSalud(
                            table.getSelectedRowModel().rows
                          )
                        }
                      >
                        <SystemUpdateAlt />
                      </IconButton>
                      <Button
                        color="info"
                        hidden={isSmallScreen}
                        disabled={
                          table.getPrePaginationRowModel().rows.length === 0
                        }
                        //export all rows, including from the next page, (still respects filtering and sorting)
                        onClick={() =>
                          handleDownloadExcelSalud(
                            table.getPrePaginationRowModel().rows
                          )
                        }
                        variant="contained"
                      >
                        <FileDownloadIcon sx={{ mr: 1 }} />
                        Exportar Todo
                      </Button>
                      <Button
                        color="success"
                        hidden={isSmallScreen}
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleDownloadExcelSalud(
                            table.getSelectedRowModel().rows
                          )
                        }
                        startIcon={<SystemUpdateAlt />}
                        variant="contained"
                      >
                        Exportar Selección
                      </Button>
                    </Box>
                  )}
                  muiTopToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableHeadCellProps={{
                    align: "center",
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiBottomToolbarProps={{
                    sx: {
                      backgroundColor: theme.palette.background.alt,
                    },
                  }}
                  muiTableBodyProps={{
                    sx: {
                      "& tr:nth-of-type(odd)": {
                        backgroundColor: theme.palette.background.light,
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    align: "center",
                  }}
                  muiTablePaperProps={{
                    elevation: 0,
                  }}
                  initialState={{
                    pagination: {
                      pageSize: 20,
                      pageIndex: 0,
                    },
                  }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10, 20, 30, 50, 100],
                    showFirstButton: false,
                    showLastButton: false,
                    SelectProps: {
                      native: true,
                    },
                    labelRowsPerPage: "Número de filas visibles",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default Consolidado;
